/**
 * @generated SignedSource<<296de75e35cb07fe080e23ace858a78e>>
 * @relayHash e8f98055e5741882d770ae3f9d601043
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ce9d09660428bd26bc6bab008de01d9b128040aa45b6652f1bca1729f0d9064

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraJqlScopeInput = {
  backlog?: JiraJqlBacklogInput | null | undefined;
  board?: JiraJqlBoardInput | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type hydrateJqlBuilderQuery$variables = {
  accountId: string;
  cloudId: string;
  filterAri: string;
  includeJira: boolean;
  includeUser: boolean;
  isFilter: boolean;
  isPlanReleaseFeatureToggleEnabled: boolean;
  jql: string;
  scope?: JiraJqlScopeInput | null | undefined;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type hydrateJqlBuilderQuery$data = {
  readonly jira?: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery?: {
        readonly __typename: "JiraJqlHydratedQuery";
        readonly jql: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly hydrateJqlQueryForFilter?: {
        readonly __typename: "JiraJqlHydratedQuery";
        readonly jql: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"jqlEditor_jqlBuilderBasic_JQLEditorUI" | "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData" | "useHydratedValues" | "useHydratedValues_cascadeSelectPicker" | "useQuery">;
};
export type hydrateJqlBuilderQuery = {
  response: hydrateJqlBuilderQuery$data;
  variables: hydrateJqlBuilderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeJira"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeUser"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFilter"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPlanReleaseFeatureToggleEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v10 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v11 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v12 = {
  "kind": "Variable",
  "name": "viewContext",
  "variableName": "viewContext"
},
v13 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "jql"
  },
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "jql"
},
v16 = [
  (v14/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v15/*: any*/)
    ],
    "type": "JiraJqlHydratedQuery"
  }
],
v17 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "filterAri"
  },
  (v11/*: any*/),
  (v12/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = [
  (v14/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v18/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v21 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v22 = {
  "kind": "ScalarField",
  "name": "key"
},
v23 = [
  {
    "concreteType": "JiraStatusCategory",
    "kind": "LinkedField",
    "name": "statusCategory",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorName"
      },
      (v18/*: any*/)
    ]
  }
],
v24 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v25 = [
  (v14/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v15/*: any*/),
      {
        "kind": "LinkedField",
        "name": "fields",
        "plural": true,
        "selections": [
          (v14/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v20/*: any*/),
              {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "concreteType": "JiraJqlSearchTemplate",
                    "kind": "LinkedField",
                    "name": "searchTemplate",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldShowInContext"
                  },
                  {
                    "condition": "isPlanReleaseFeatureToggleEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          (v11/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "shouldExcludeInScope"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "operators"
                  },
                  {
                    "concreteType": "JiraFieldType",
                    "kind": "LinkedField",
                    "name": "fieldType",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "small"
                                      }
                                    ]
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlProjectFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "JiraJqlStatusFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "JiraJqlStatusCategoryFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "xsmall"
                                      }
                                    ]
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueTypeFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v19/*: any*/)
                              }
                            ],
                            "type": "JiraJqlUserFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlPriorityFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v14/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "text"
                                                  }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              (v18/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "state"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "boardName"
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlSprintFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v24/*: any*/),
                              {
                                "concreteType": "JiraJqlCascadingOptionFieldValue",
                                "kind": "LinkedField",
                                "name": "parentOption",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v20/*: any*/),
                                  (v24/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlCascadingOptionFieldValue"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedValue"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*: any*/),
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "error",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedError"
                  }
                ]
              }
            ],
            "type": "JiraJqlQueryHydratedField"
          }
        ]
      }
    ],
    "type": "JiraJqlHydratedQuery"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ],
    "type": "QueryError"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hydrateJqlBuilderQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
      },
      {
        "kind": "FragmentSpread",
        "name": "useHydratedValues"
      },
      {
        "kind": "FragmentSpread",
        "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
      },
      {
        "kind": "FragmentSpread",
        "name": "useQuery"
      },
      {
        "kind": "FragmentSpread",
        "name": "useHydratedValues_cascadeSelectPicker"
      },
      {
        "condition": "includeJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": (v13/*: any*/),
                        "kind": "LinkedField",
                        "name": "hydrateJqlQuery",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v17/*: any*/),
                        "kind": "LinkedField",
                        "name": "hydrateJqlQueryForFilter",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "hydrateJqlBuilderQuery",
    "selections": [
      {
        "condition": "includeUser",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
              }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v19/*: any*/)
          }
        ]
      },
      {
        "condition": "includeJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": (v13/*: any*/),
                        "kind": "LinkedField",
                        "name": "hydrateJqlQuery",
                        "plural": false,
                        "selections": (v25/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v17/*: any*/),
                        "kind": "LinkedField",
                        "name": "hydrateJqlQueryForFilter",
                        "plural": false,
                        "selections": (v25/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6ce9d09660428bd26bc6bab008de01d9b128040aa45b6652f1bca1729f0d9064",
    "metadata": {},
    "name": "hydrateJqlBuilderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "30fd8badf71c8e43e13c94db5bb98b42";

export default node;
